/**
=========================================================
* Material Dashboard 3 PRO React - v2.4.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { forwardRef } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Custom styles for MDAvatar
import MDAvatarRoot from "components/MDAvatar/MDAvatarRoot";

const MDAvatar = forwardRef(
	({ bgColor = "transparent", size = "md", shadow = "none", ...rest }, ref) => (
		<MDAvatarRoot ref={ref} ownerState={{ shadow, bgColor, size }} {...rest} />
	)
);

// Typechecking props for the MDAvatar
MDAvatar.propTypes = {
	bgColor: PropTypes.oneOf([
		"transparent",
		"primary",
		"secondary",
		"info",
		"success",
		"warning",
		"error",
		"light",
		"dark"
	]),
	size: PropTypes.oneOf(["xs", "sm", "md", "lg", "xl", "xxl"]),
	shadow: PropTypes.oneOf([
		"none",
		"xs",
		"sm",
		"md",
		"lg",
		"xl",
		"xxl",
		"inset"
	])
};

export default MDAvatar;
